import {
  NoResultsFallbackIcon,
  ZeroStateFallbackIcon
} from "../../Assets/assets";
import Button from "../Button/Button";

export const ZeroStateFallback = (props) => {
  return (
    <div
      className="inherit-parent-height padding-horizontal-large display-flex flex-direction-column flex-justify-content-center flex-align-items-center"
      data-cy={`ZERO-STATE-${props.type}-FALLBACK`}
    >
      <ZeroStateFallbackIcon />
      <div className="padding-top-larger font-color-tertiaryColor6">
        {props.title}
      </div>
      <div className="padding-top-medium text-align-center font-size-medium font-color-tertiaryColor5">
        {props.description}
      </div>
    </div>
  );
};

export const NoResultsFallback = (props) => {
  return (
    <div
      className="inherit-parent-height padding-horizontal-large display-flex flex-direction-column flex-justify-content-center flex-align-items-center"
      data-cy={`NO-RESULTS-${props.type}-FALLBACK`}
    >
      <NoResultsFallbackIcon />
      <div className="padding-top-larger font-color-tertiaryColor6">
        Couldn’t find proper match
      </div>
      <div className="padding-top-medium text-align-center font-size-medium font-color-tertiaryColor5 padding-bottom-large">
        TRY DIFFERENT FILTER, SEARCH TERM, OR
      </div>
      <Button
        variant="danger"
        boxShadow={false}
        text="Reset"
        onClick={props.resetOnClick}
      />
    </div>
  );
};
